import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { resourceEndpoints } from '../../services/api/endpoints/resource.endpoint';
import { Resource } from '../../types/resource';
import { logger } from '../../utils/logger';

export const useResources = () => {
  const [resources, setResources] = useState<Resource[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  const fetchResources = useCallback(async () => {
    if (!selectedOrganizationId) return;

    setIsLoading(true);
    setError(null);

    try {
      const data = await resourceEndpoints.listResources(selectedOrganizationId);
      setResources(data);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch resources';
      setError(message);
      logger.error('Error fetching resources:', err);
    } finally {
      setIsLoading(false);
    }
  }, [selectedOrganizationId]);

  useEffect(() => {
    fetchResources();
  }, [fetchResources]);

  return {
    resources,
    isLoading,
    error,
    selectedOrganizationId,
    refetch: fetchResources,
  };
};
